export default __webpack_public_path__ + "45cbf9b0741078cc2ca8dff493ddf17f.svg";